import React from 'react';
import { heroData } from '../data';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import { Link } from 'react-scroll'; // Import Link from react-scroll

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.6,
    },
  },
};

const Hero = () => {
  const { title, subtitle, btnText, btnIcon } = heroData;

  return (
    <section className='bg-hero bg-cover bg-center min-h-[40vh] lg:h-[948px] bg-no-repeat relative mt-[120px] lg:mt-[150px]'>
      <motion.div
        variants={container}
        initial="hidden"
        whileInView={'show'}
        className='container mx-auto min-h-[40vh] lg:h-full flex flex-col items-end justify-center text-right'
        style={{ paddingRight: '5%' }}
      >
        <div className='text-white flex flex-col items-end' style={{ maxWidth: '600px' }}>
          <motion.h1
            variants={fadeIn('down')}
            className='h1 font-bold mb-2 lg:mb-4'
            style={{ fontSize: '68px', fontWeight: 'normal', lineHeight: '1.2', width: '100%' }}
          >
            {title}
          </motion.h1>
          <motion.p
            variants={fadeIn('down')}
            className='mb-4 lg:mb-6 font-semibold'
            style={{ fontSize: '24px', fontWeight: '700', width: '100%' }}
          >
            {subtitle}
          </motion.p>
          <motion.div variants={fadeIn('down')} className='mt-4 self-end'>
            <Link
              to="about" // The ID of the target section
              smooth={true}
              duration={500}
            >
              <button className='btn btn-sm lg:btn-lg btn-outline'>
                {btnText} <div className='text-xl'>{btnIcon}</div>
              </button>
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
